var csrfTokenTag = typeof document === 'undefined' ? null : document.querySelector('meta[name=csrf-token]');
export default csrfTokenTag ? csrfTokenTag.content : null;